// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2G-qd","description":"PatientConsentPreview_description__Xq9ON"};